var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.500122,
    width: 15,
    height: 15,
    rx: 4.5,
    fill: "#E4ECFC",
    stroke: "#CBD8F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.409 11.8896L3.22701 8.70759L4.642 7.2926L6.409 9.06459L11.358 4.1106L12.773 5.5256L6.409 11.8896Z",
    fill: "#1033A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBox);
export default __webpack_public_path__ + "static/media/CheckBox.33c82fd86f02684c2395015409034dd2.svg";
export { ForwardRef as ReactComponent };